
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/termos",
      function () {
        return require("private-next-pages/auth/termos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/termos"])
      });
    }
  